import { Component } from 'react';
import {
    isEmpty,
    isEqual,
    get,
    head
} from 'lodash';

import DataTypeEditor from 'common/components/DataTypeEditor/DataTypeEditor';
import styles from '../ValueSets.scss';

class ScalarValue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.validationErrors, this.props.validationErrors)) {
            this.setState({
                errorMessage: get(head(this.props.validationErrors), 'message')
            });
        }
    }

    hasError() {
        const {
            validationErrors,
            value
        } = this.props;

        return !value && !isEmpty(validationErrors);
    }

    _getClassName() {
        const { dataType } = this.props;
        const hasError  = this.hasError();

        if (hasError) {
            return styles.inputDefaultError;
        }

        switch (dataType && dataType.toLowerCase()) {
            case 'small_text':
                return hasError ? styles.inputTextError : styles.inputText;
            case 'integer':
                return hasError ? styles.inputTextError : styles.inputText;
            case 'dateonly':
                return styles.inputDate;
            case 'datetime':
                return styles.inputDate;
            default:
                return styles.inputDefault;
        }
    }

    render() {
        const {
            dataType,
            changeHandler,
            value
        } = this.props;
        const {
            errorMessage
        } = this.state;

        
        const placeholder = isEmpty(value) ? 'Enter value here' : '';

        return (
            <div className={styles.inputWrapper} data-cy="scalarValue">
                { this.hasError() &&
                    <span className={styles.errorMessage}>{errorMessage}</span>
                }
                <DataTypeEditor
                    dataType={dataType}
                    className={this._getClassName()}
                    value={value}
                    placeholder={placeholder}
                    changeHandler={e => changeHandler(e.target.value)} />
            </div>
        );
    }
}

export default ScalarValue;
